import { useState } from "react";
import { useSelector } from "react-redux";

import RenderHtmlText from "../utilities/renderhtmltext";
import { Mixpanel } from '../utilities/analytics/mixpanelHelpers';
import AiTalkMessageScore from "./aiTalkMessageScore";
import ScoreDetailsBiteLite from "../utilities/learning_module/scoreDetailsBiteLite";
import AvatarWithAudio from "../utilities/avatars/avatarWithAudio";
import ScoreHelperHint from "../utilities/scoreHelperHint";


function Message(props) {

  // Define variables
  const isIelts = useSelector((state) => state.aiTalk.isIelts);
  const [translatedFeedback, setTranslatedFeedback] = useState(null);
  const [modal, setModal] = useState(null);
  const [improveText, setImproveText] = useState(null);
  const hasPremium = props.hasPremium;
  const messageIndex = props.messageIndex;
  const iconUrl = props.iconUrl;
  const avatarUrl = props.avatarUrl;
  const message = props.message;
  const role = message.role;
  const content = message.content;
  const audioUrl = message.audioUrl;
  const display = message.display;
  const responseObject = message.responseObject;
  const generateTips = props.generateTips;
  const canShowScoreHint = props.canShowScoreHint;

  const translateToggle = props.translateToggle;
  const translation = props.translation ? props.translation.translation : null;


  // Define functions
  function openModal() {
    setModal(
      <AiTalkMessageScore
        responseObject={responseObject}
        closeModal={closeModal}
        improveText={improveText}
        setImproveText={setImproveText}
        generateTips={generateTips}
        messageIndex={messageIndex}
        isIelts={isIelts}
        translatedFeedback={translatedFeedback}
        setTranslatedFeedback={setTranslatedFeedback}
      />
    );
    Mixpanel.track('Event: AI Talk see tips');
  }

  function closeModal(){
    setModal(null);
  }

  // Screen components
  let messageElement;
  if( role === 'user' ) {

    let scoreElement;
    let scoreDetailsHelper;

    if( responseObject ) {

      let overallScore;
      if( responseObject?.overall?.percent ) {
        overallScore = `${responseObject.overall.percent}% `;

        scoreElement = (
          <div class='flex-row aitalk-score-button-container'>
            <button
              type='button'
              class='clean-button aitalk-score-button'
              onClick={() => openModal()}
            >
              <ScoreDetailsBiteLite
                responseObject={responseObject}
                ieltsCourse={false}
              />
            </button>
          </div>
        );


        if( canShowScoreHint ) {
          scoreDetailsHelper = (
            <div class='aitalk-score-helper-hint-container'>
              <ScoreHelperHint />
            </div>
          );
        }

      }
    }

    messageElement = (
      <div>
        <div class='aitalk-message-container learner'>
          <div class='flex-row aitalk-message'>
            <p>{content}</p>
          </div>
          <AvatarWithAudio
            type='learner'
            avatarUrl={avatarUrl}
            audioUrl={audioUrl}
          />
        </div>
        {scoreElement}
        {scoreDetailsHelper}
      </div>
    );

  } else if( role === 'assistant' ) {

    let translateElement;
    if( translateToggle && translation ) {
      translateElement = (
        <div class='translate-container fade-in-on-load'>
          <RenderHtmlText string={translation} />
        </div>
      );
    }

    messageElement = (
        <div class='aitalk-message-container assistant'>
          <AvatarWithAudio
            type='assistant'
            avatarUrl={iconUrl}
            audioUrl={audioUrl}
            message={content}
            speakerId={getSpeakerId(iconUrl)}
            hasPremium={hasPremium}
          />

          <div>
            <div class='flex-row aitalk-message'>
              <p>{content}</p>
            </div>
            {translateElement}
          </div>
        </div>
    );

  }

  if( display === false ) {
    messageElement = null;
  }


  return (
    <div>
      {modal}
      {messageElement}
    </div>
  );
}

export default Message;



function getSpeakerId(iconUrl) {
  let speakerId = 1;

  if( iconUrl ) {
    if( iconUrl.includes('woman-one') ) {
      speakerId = 3
    } else if( iconUrl.includes('woman-two') ) {
      speakerId = 5
    } else if( iconUrl.includes('woman-three') ) {
      speakerId = 6
    } else if( iconUrl.includes('man-one') ) {
      speakerId = 1
    } else if( iconUrl.includes('man-two') ) {
      speakerId = 2
    } else if( iconUrl.includes('man-three') ) {
      speakerId = 4
    } else if( iconUrl.includes('woman-four') ) {
      speakerId = 5
    } else if( iconUrl.includes('man-four') ) {
      speakerId = 2
    } else if( iconUrl.includes('woman-five') ) {
      speakerId = 6
    } else if( iconUrl.includes('man-five') ) {
      speakerId = 1
    }
  }

  return speakerId;
}